import {
  ThemeProvider as SignetThemeProvider,
  type Theme,
  useTheme,
} from "@nimit9/signet-ui/components/theme-provider"

export type { Theme }
export { useTheme }

/** Kept from before the Signet migration so existing users keep their choice
 * (index.html's pre-paint script reads the same key). */
const STORAGE_KEY = "paisa-theme"

/** Match the mobile browser chrome to the Fern header surface. Signet's
 * default sync would use --background (the page canvas), which is a shade
 * off, so its `themeColor` gets the surface colour per resolved theme. */
const THEME_COLOR = { dark: "#171b21", light: "#ffffff" } as const
const themeColor = (resolved: "light" | "dark") => THEME_COLOR[resolved]

/** Signet's ThemeProvider (`.dark` class, follows the OS on "system"), keyed to
 * paisa's storage and syncing `<meta name="theme-color">` to the header surface. */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <SignetThemeProvider storageKey={STORAGE_KEY} themeColor={themeColor}>
      {children}
    </SignetThemeProvider>
  )
}
